import { createContext, useContext, useEffect, useState } from "react";
import config from "../config";

let cachedCities = null;
let cachedOccasions = null;
let pendingCities = null;
let pendingOccasions = null;

function loadCities() {
  if (cachedCities !== null) return Promise.resolve(cachedCities);
  if (pendingCities) return pendingCities;
  pendingCities = fetch(`${config.BACKEND_BASE_URL}/api/filters/cities`)
    .then((res) => { if (!res.ok) throw new Error(); return res.json(); })
    .then((data) => { cachedCities = Array.isArray(data) ? data : []; return cachedCities; })
    .catch(() => { cachedCities = []; return cachedCities; });
  return pendingCities;
}

function loadOccasions() {
  if (cachedOccasions !== null) return Promise.resolve(cachedOccasions);
  if (pendingOccasions) return pendingOccasions;
  pendingOccasions = fetch(`${config.BACKEND_BASE_URL}/api/filters/occasions`)
    .then((res) => { if (!res.ok) throw new Error(); return res.json(); })
    .then((data) => { cachedOccasions = Array.isArray(data) ? data : []; return cachedOccasions; })
    .catch(() => { cachedOccasions = []; return cachedOccasions; });
  return pendingOccasions;
}

const FiltersContext = createContext({ cities: null, occasions: null });

export function FiltersProvider({ children }) {
  const [cities, setCities] = useState(cachedCities);
  const [occasions, setOccasions] = useState(cachedOccasions);

  useEffect(() => {
    if (cachedCities === null) loadCities().then(setCities);
    if (cachedOccasions === null) loadOccasions().then(setOccasions);
  }, []);

  return (
    <FiltersContext.Provider value={{ cities, occasions }}>
      {children}
    </FiltersContext.Provider>
  );
}

export const useFilters = () => useContext(FiltersContext);
